
import { computed, defineComponent, PropType } from 'vue';
import { B2CGoodThingsToComeTileModel } from '@/types/B2CcontentServerContract';
import CMSLinkHandler from '@/shared/content/blocks/helpers/CMSLinkHandler.vue';
import VideoPlayer from '@/shared/VideoPlayer.vue';
import { useRouteQuery } from '@/core/browser/route-query.composable';
import { QueryKeys } from '@/shared/config/route-query.config';
import responsiveImageService from '@/core/responsive/image/responsive-image.service';
import gtm from '@/shared/tracking/gtm.service';

export default defineComponent({
    name: 'B2CGoodThingsToComeTile',
    components: { VideoPlayer, CMSLinkHandler },
    props: {
        content: {
            type: Object as PropType<B2CGoodThingsToComeTileModel>,
            required: true,
        },
    },
    setup(props) {
        const cdnUrls = responsiveImageService.getBaseUrls();
        const baseUrl = `${cdnUrls.cdnProductImages}/gtc`;
        const videoId = useRouteQuery(QueryKeys.VideoId);
        const videoUrl = computed(() => videoId.value ? `${baseUrl}/${videoId.value}.mp4` : props.content.fallbackVideoSrc);
        const videoPoster = computed(() => videoId.value ? `${baseUrl}/${videoId.value}.jpg` : '');

        const trackVideoStart = () => {
            gtm.goodThingsToComeVideo('Start');
        };

        const trackVideoEnd = () => {
            gtm.goodThingsToComeVideo('End');
        };

        const trackVideoProgress = (progress: string) => {
            gtm.goodThingsToComeVideo(progress);
        };

        return {
            videoUrl,
            videoPoster,
            trackVideoStart,
            trackVideoEnd,
            trackVideoProgress,
        };
    },
});
